import { AdornmentType } from 'app/shared/componentsRestyled/coreDesignSystem/form/DataFieldCDS/DataFieldCDS.constants';
import { PricingTargetType } from 'app/shared/modules/PricingWorkbench/PricingWorkbench.constants';
import { TARGET_PLACEHOLDER } from 'app/shared/modules/PricingWorkbench/ProgramFilterPanel/ProgramFilterPanel.constants';

import { FieldInputType } from 'constants/fields';
import { DesiredTargetMaxValue } from 'constants/programs';

export const DESIRED_TARGET_INPUT_WIDTH = '140px';

export const DesiredTargetInputProps = {
  [PricingTargetType.RATE]: {
    type: FieldInputType.PERCENTAGE_RESTYLED,
    adornmentType: AdornmentType.END,
    maxValue: DesiredTargetMaxValue[PricingTargetType.RATE],
    placeholder: TARGET_PLACEHOLDER[PricingTargetType.RATE],
    ariaLabel: 'Desired rate',
  },
  [PricingTargetType.PRICE]: {
    type: FieldInputType.FLOAT,
    adornmentType: AdornmentType.START,
    maxValue: DesiredTargetMaxValue[PricingTargetType.PRICE],
    placeholder: TARGET_PLACEHOLDER[PricingTargetType.PRICE],
    ariaLabel: 'Desired price (100 is par)',
  },
};
